import { Children } from "react";
import { Text, Wrap, WrapItem, useColorModeValue } from "@chakra-ui/react";
import { TEXT_COLOR_LIGHT, TEXT_COLOR_DARK } from "./utils";

interface Props {
  children: JSX.Element | JSX.Element[];
  title: string;
}

export function FilterSection({ title = "", children }: Props) {
  const textColor = useColorModeValue(TEXT_COLOR_LIGHT, TEXT_COLOR_DARK);
  const arrayChildren = Children.toArray(children);

  return (
    <>
      <Text fontSize="13px" ml="3" fontWeight="semibold" color={textColor}>
        {title}
      </Text>
      <Wrap py="2" spacingY="4">
        {arrayChildren.map((c) => (
          <WrapItem>{c}</WrapItem>
        ))}
      </Wrap>
    </>
  );
}
